import { Component, OnInit, Input } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from '../baseComponent';
import { MsgService } from '../../services/local/msg.service';
import { Router } from '@angular/router';
import { PageService } from '../../services/api/page.service';
import { Page } from '../../models/entity/page.model';
import { FilterBaseModel } from '../../models/viewModel/filterBase.model';
import { ServicesService } from '../../services/api/services.service';
import { GeneralInfoService } from '../../services/api/generalInfo.service';
import { Service } from '../../models/entity/service.model';
import { GeneralInfo } from '../../models/entity/genaralInfo.model';
import { SocialService } from '../../services/api/social.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: [
  ]

})

export class HeaderComponent extends BaseComponent implements OnInit {
  // ============= [Data] =============
  menus: Page[] = [];
  services: Service[] = [];
  socials: any[] = [];
  generalInfo: GeneralInfo = new GeneralInfo();
  // ============= [Config] =============
  filterService: FilterBaseModel = new FilterBaseModel();
  constructor(
    protected messageService: MsgService,
    protected router: Router,
    //
    protected dialogService: DialogService,
    protected pageService: PageService,
    protected servicesService: ServicesService,
    protected socialService: SocialService,
    protected generalInfoService: GeneralInfoService,
  ) {
    super(messageService, router);
  }

  ngOnInit(): void {
    this.initData();
  }
  // ============= [Data] =============
  async initData(): Promise<any> {
    this.getMenu();
    this.getServices();
    this.getSocials();
    this.getGeneralInfo();
  }
  async getMenu(): Promise<any> {
    const result = await this.pageService.getListPagePublic();
    if (result.data.length > 0) {
      this.menus = result.data;
      this.menus = this.menus.sort((a, b) => a.pageOrder - b.pageOrder);
    }
  }
  async getServices(): Promise<any> {
    this.filterService.pageSize = 6;
    const rep = await this.servicesService.getListService(this.filterService);
    if (rep.data.length > 0) {
      this.services = rep.data as Service[];
      this.services = this.services.sort(s => -s.id);
    } else {
      this.services = [];
    }
  }
  
  async getSocials(): Promise<any> {
    this.filterService.pageSize = 6;
    const rep = await this.socialService.getAll();
    if (rep.data.length > 0) {
      this.socials = rep.data as [];
      // this.socials = this.socials.sort(s => -s.id);
    } else {
      this.socials = [];
    }
  }

  async getGeneralInfo(): Promise<any> {
    const rep = await this.generalInfoService.getGeneralInfo();
    if (rep) {
      this.generalInfo = rep;
    } else {
      this.generalInfo = new GeneralInfo();
    }
  }

  getSocial(str) {
    if (str == "facebook") {
      return "fa-facebook";
    } else if (str == "twitter") {
      return "fa-twitter";
    } else if (str == "linkedin") {
      return "fa-linkedin";
    } else if (str == "google") {
      return "fa-google-plus";
    }
    return "bb";
  }
  // ============= [/Data] =============
}
